<div class="row mx-2 mt-2 mb-2">
  <div class="col-md-12">
    <h4>Kitchen Stock Requirement</h4>
  </div>
</div>


<form [formGroup]="form"  autocomplete="off"  class="form-horizontal">   
  <div class="card m-2" [ngClass]="{'dark-bg' : isDark }">
    <div class="card-body">   
          <div class="row">    
            <div class="col-md-3">
              <div class="form-group">
                <label for="docNo" class="col-form-label">Document No</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-hashtag"></i></span>
                  </div>
                  <input type="text" [ngClass]="{'dark-input-field' : isDark }" readonly formControlName="docNo" class="form-control field-bg-color" placeholder="Auto Generated">
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="docDate" class="col-form-label">Document Date </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-calendar-o"></i></span>
                  </div>
                  <input type="text" [ngClass]="{'dark-input-field' : isDark }" bsDatepicker [bsConfig]="datepickerConfig" formControlName="docDate" class="form-control field-bg-color"  [class.is-invalid]="formErrors.docDate" (blur)="logValidationErrors()" placeholder="Document Date">
                </div>
                <span class="text-danger" *ngIf="formErrors.docDate"><small>{{formErrors.docDate}}</small> </span>   
              </div>
            </div>         

          </div>

      </div>  <!-- /.card-body -->
    </div> <!-- /.card -->

    <div class="card m-2" [ngClass]="{'dark-bg' : isDark }">
      <div class="card-body"> 

          <div class="row"> 
            <div class="col-md-12">
            <table class="table table-sm mt-2 table-bordered" [ngClass]="{'dark-bg' : isDark }">  
              <thead class="thead-light"  [ngClass]="{'dark-input-field' : isDark }" [ngClass]="{'thead-light' : !isDark }">
                <tr>
                  <th style="width: 30%"  scope="col">ITEM NAME</th>
                  <th style="width: 10%"  scope="col">UNIT</th>
                  <th style="width: 10%"  scope="col" style="text-align: center">QTY BAL</th>
                  <th style="width: 10%"  scope="col" style="text-align: center">REQ QTY</th>
                  <th style="width: 10%"  scope="col" style="text-align: center">TOTAL QTY</th>
                  <th style="width: 15%"  scope="col" style="text-align: center">UNIT COST</th>
                  <th style="width: 15%" scope="col" style="text-align: center">TOTAL COST</th>
                  <th *ngIf="!isHideBtn"></th> 
                </tr>
                </thead>
    
                <tbody class="ml-1" formArrayName="invoiceItems" *ngFor="let invoiceItem of form.get('invoiceItems')['controls']; let i = index">                    
                      <tr [formGroupName] = "i" >     
                        <td class="d-none"><input type="hidden"  [ngClass]="{'dark-input-field' : isDark }"  readonly class="form-control form-control-sm" formControlName="itemId"></td>                             
                          <td><input [ngClass]="{'dark-input-field' : isDark }" readonly type="text" class="form-control form-control-sm field-bg-color" formControlName="item" [class.is-invalid]="invoiceItem.get('item').invalid && invoiceItem.get('item').touched"></td> 
                          <td><input [ngClass]="{'dark-input-field' : isDark }" readonly type="text" class="form-control form-control-sm field-bg-color" formControlName="unit" [class.is-invalid]="invoiceItem.get('unit').invalid && invoiceItem.get('unit').touched"></td>  
                          <td><input [ngClass]="{'dark-input-field' : isDark }" [readonly]="isfieldReadOnly" type="text"   style="text-align: right"   class="form-control form-control-sm field-bg-color" formControlName="qtyInStock"></td>                        
                          <td><input [ngClass]="{'dark-input-field' : isDark }" [readonly]="isfieldReadOnly" type="text"  style="text-align: right"    class="form-control form-control-sm field-bg-color" formControlName="qty" [class.is-invalid]="invoiceItem.get('qty').invalid && invoiceItem.get('qty').touched"></td>
                          <td><input [ngClass]="{'dark-input-field' : isDark }" readonly type="text"  style="text-align: right"   class="form-control form-control-sm field-bg-color" formControlName="totalQty" [class.is-invalid]="invoiceItem.get('totalQty').invalid && invoiceItem.get('totalQty').touched"></td> 
                          <td><input [ngClass]="{'dark-input-field' : isDark }" [readonly]="isfieldReadOnly" type="text"  style="text-align: right"    class="form-control form-control-sm field-bg-color" formControlName="unitCost" [class.is-invalid]="invoiceItem.get('unitCost').invalid && invoiceItem.get('unitCost').touched"></td> 
                          <td><input [ngClass]="{'dark-input-field' : isDark }"    type="text" style="text-align: right"  readonly class="form-control form-control-sm field-bg-color" formControlName="totalCost"></td>    
                          <td *ngIf="!isHideBtn">
                            <button *ngIf="!isBtnDisabled && form.get('invoiceItems').length > 1" class="btn btn-danger btn-sm ml-1 text-white" (click)="removeItemButtonClick(i,invoiceItem)" data-toggle="deleteTooltip" data-placement="bottom" title="Delete"><i class="fa fa-close"></i></button>         
                        </td>                    
                        </tr>                                                       
                </tbody>
            </table> 
          </div> 
        </div>



        </div>  <!-- /.invoice line card-body -->
      </div> <!-- /.invoice line card -->



      <div class="card m-2" [ngClass]="{'dark-bg' : isDark }">
        <div class="card-body"> 
          <div class="row mt-3 mr-4">
            <div class="col-md-4" *ngIf="showInvoicePmtDetails">
              <div class="form-group">
            <table class="table  table-clear table-sm" [ngClass]="{'dark-bg' : isDark }">
            <tbody>
              <tr>
                <td colspan="2" class="text-center pt-2"><strong>Details</strong></td>                
            </tr> 
             <tr>
                <td  class="pt-2">Status</td>
                <td>{{stockRequirement.status}}</td>
            </tr> 
            <tr>
                <td  class="pt-2">Created By</td>
                <td>{{stockRequirement.createdBy}}</td>
            </tr> 
            </tbody>
          </table>
              </div>
          </div>
        
            <div class="col-md-4"  [class.offset-md-4]='bsClassToShow' [class.offset-md-8]='!bsClassToShow'>
              <table class="table table-clear" [ngClass]="{'dark-bg' : isDark }">
                <tbody>
                <tr class="row">
                <td class="left col-sm-4">
                <strong>Grand Total</strong>
                </td>  
                <td class="col-sm-3"></td>             
                <td class="text-right col-sm-5">
                <strong>{{stockRequirement.grandTotal | number:'1.2-2'}}</strong>
                </td>
                </tr>
                </tbody>
                </table>              
          </div>
        </div>
  
      
      </div>  <!-- /.invoice line card-body -->
    </div> <!-- /.invoice line card -->
          
    <div class="card m-2" [ngClass]="{'dark-bg' : isDark }">
      <div class="card-body"> 
        <!-- <button type="button" *ngIf="crud_access.create" (click)="newButtonClick()" class="btn btn-success ml-2">New</button> -->
          <button type="button" *ngIf="crud_access.create && !isBtnDisabled"  (click)="saveButtonClick()" class="btn btn-info ml-2">
           <span *ngIf ="showProcessingIndicator" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
            Save
          </button>
          <button type="button" *ngIf="!isChangeOrderBtnDisabled" class="btn btn-secondary ml-2"  (click)="changeOrderBtnClicked()">
            Change Order
          </button>
          <button type="button" *ngIf="crud_access.delete && !isCancelBtnDisabled" class="btn btn-danger ml-2" (click)="deleteButtonClick()">Cancel</button>
          <button type="button" class="btn btn-success ml-2" routerLink="../stock-requirement-list">Back to List</button>
          <button type="button" *ngIf="isShowPayBtn" class="btn btn-info ml-2" (click)="paidBtnClick()">Approved & Paid</button>

          <!-- <button  *ngIf ="isShowAttachBtn" class="btn btn-primary ml-2" (click)="attachFileButtonClick()"><i class="fa fa-plus p-1"></i>Attach Files</button> -->

         
          <button type="button" (click)="savePDF('print')"  mat-icon-button class="text-info float-right">
            <mat-icon>print</mat-icon>
          </button>
          <button type="button" (click)="savePDF('download')"  mat-icon-button class="text-success float-right">
            <mat-icon>cloud_download</mat-icon>
          </button>
          <button  type="button" (click)="savePDF('open')"  mat-icon-button class="text-dark float-right">
            <mat-icon [ngClass]="{'dark-bg' : isDark }">preview</mat-icon>
          </button>
        
        </div>  <!-- /.invoice line card-body -->
      </div> <!-- /.invoice line card -->

    </form>




    <!-- Form Values : {{ form.value | json }}   -->


